/* EcoSparkle Home — Starter Kit JS */

/* ── Add to cart → checkout ── */
async function addStarterToCart() {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: STARTER_VARIANT_ID, quantity: 1 }] })
    });
    if (res.ok) {
      if (window.gtag) gtag('event', 'add_to_cart', { value: 300, currency: 'ILS' });
      if (window.fbq)  fbq('track', 'AddToCart', { value: 300, currency: 'ILS' });
      window.location.href = '/checkout';
    } else {
      const err = await res.json();
      alert(err.description || 'משהו השתבש. נסו שוב.');
    }
  } catch (e) {
    alert('שגיאת רשת. בדקו חיבור לאינטרנט ונסו שוב.');
  }
}

/* ── Countdown (resets daily at midnight Asia/Jerusalem) ── */
(function initCountdown() {
  function getTarget() {
    const now = new Date();
    const target = new Date(now);
    target.setHours(23, 59, 59, 999);
    return target;
  }
  let target = getTarget();

  function tick() {
    const diff = target - Date.now();
    if (diff <= 0) { target = getTarget(); }
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const hEl = document.getElementById('cntH');
    const mEl = document.getElementById('cntM');
    const sEl = document.getElementById('cntS');
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

/* ── Sticky CTA (shows after 800px scroll) ── */
(function initStickyCta() {
  const el = document.getElementById('stickyCta');
  if (!el) return;
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        const show = window.scrollY > 800;
        el.classList.toggle('visible', show);
        el.setAttribute('aria-hidden', String(!show));
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── FAQ accordion ── */
(function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const answer = btn.nextElementSibling;

      /* Close all others */
      document.querySelectorAll('.faq-q[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.hidden = true;
        }
      });

      btn.setAttribute('aria-expanded', String(!expanded));
      answer.hidden = expanded;
    });
  });
})();

/* ── Intersection observer — fade-in sections ── */
(function initFadeIn() {
  const sections = document.querySelectorAll('.fade-in-section');
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('visible'); });
    return;
  }
  const obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  sections.forEach(function (s) { obs.observe(s); });
})();

/* ── UGC carousel — smooth drag scroll ── */
(function initCarousel() {
  const track = document.querySelector('.ugc-carousel');
  if (!track) return;
  let isDown = false, startX = 0, scrollLeft = 0;

  track.addEventListener('mousedown', function (e) {
    isDown = true;
    track.style.cursor = 'grabbing';
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  track.addEventListener('mouseleave', function () {
    isDown = false;
    track.style.cursor = 'grab';
  });
  track.addEventListener('mouseup', function () {
    isDown = false;
    track.style.cursor = 'grab';
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX) * 1.5;
  });
})();

/* ── Smooth scroll for anchor links ── */
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
